import {
    SET_LOGOUT
} from './actionTypes'

export function setLogout (isLogout) {
    return { type: SET_LOGOUT, isLogout }
}
